import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { chartFingerprint, useSavedCharts } from "../../accounts/SavedChartsProvider";
import classes from "./MyCharts.module.css";

const fields = ["title", "introduction", "intervalColors", "guitarSetup", "tuning", "midiRootNote",
  "imageScale", "selectNps", "intervals", "refineData"];
const selectFingerprint = createSelector(fields.map(field => state => state[field]), (...values) => {
  try { return chartFingerprint(Object.fromEntries(fields.map((field, index) => [field, values[index]]))); }
  catch { return null; }
});

const ChartSaveToolbar = ({ compact = false, allowCopy = true }) => {
  const saved = useSavedCharts();
  const fingerprint = useSelector(selectFingerprint);
  if (!saved.configured) return null;
  return <div className={`${classes.toolbar} ${saved.ready ? classes.signedIn : ""} ${compact ? classes.compact : ""}`} role="group" aria-label="Save chart set">
    {saved.ready ? <>
      <button data-tour-target="chart-save" disabled={saved.busy || !fingerprint} onClick={() => saved.save(false)}>{saved.busy ? "Saving…" : "Save chart set"}</button>
      {allowCopy && <button disabled={saved.busy || !fingerprint} onClick={() => saved.save(true)}>Save a copy</button>}
      <span role="status">{saved.active && fingerprint === saved.active.baseline ? "Saved" : "Unsaved changes"}</span>
      {!fingerprint && <p className={classes.message}>Check the chart settings before saving.</p>}
    </> : <Link to="/account" data-tour-target="chart-save">Sign in to save charts</Link>}
    {saved.error && <p className={classes.message} role="alert">{saved.error}</p>}
    {saved.message && saved.message !== "Saved to My Charts." && <p className={classes.message} role="status">{saved.message}</p>}
  </div>;
};

export default ChartSaveToolbar;
